import { BRAND_LIST, CountryLanguageSwitcher } from 'typings'
import * as Typings from '../typings'

const DenmarkLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'dk',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Denmark',
  SHORT_NAME: 'DK',

  DISPLAY_NAME: 'Denmark (English)',
  DISPLAY_COUNTRY: 'Denmark',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 56.2050544,
    INITIAL_LONGITUDE: 8.9041622,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Hovedstaden',
    '2': 'Midtjylland',
    '3': 'Nordjylland',
    '4': 'Sjælland',
    '5': 'Syddanmark',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/dk/en/',

  MAP_URL: 'https://www.uniqlo.com/dk/en/content/store-locator.html',
  MAP_MOBILE_URL: 'https://map.uniqlo.com/dk/en/',

  CONTACT_US_URL: 'https://faq-dk.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-dk.uniqlo.com/pkb_Home_UQ_DK?l=en&c=category_uq_eu_dk_se%3ARenew_UQDK_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-dk.uniqlo.com/pkb_Home_UQ_DK?l=dk&c=category_uq_eu_dk_se%3ARenew_UQDK_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default DenmarkLocale
